import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  default: css`
    &.MuiOutlinedInput-root {
      background: ${colors.mercury} !important;
      border: 1px solid ${colors.silver};
      &.Mui-focused {
        background: ${colors.white} !important;
        border: 2px solid ${colors.neutralAsh};
      }
    }
  `,
  filled: css`
    &.MuiOutlinedInput-root {
      background: ${colors.white} !important;
      border: 2px solid ${colors.neutralAsh};
    }
  `,
  searchBar: css`
    &.MuiOutlinedInput-root {
      font-size: ${pxToRem(16)};
      height: ${pxToRem(40)} !important;
      font-family: 'Montserrat Medium' !important;
      letter-spacing: -0.4px;
      line-height: 1.43;
      color: ${colors.prussian};
      padding-left: ${pxToRem(8)};
      padding-right: ${pxToRem(8)};
      height: ${pxToRem(36)};
      width: 100%;
      border-radius: 8px;
      &.Mui-focused {
        background: ${colors.white} !important;
        border: 2px solid ${colors.neutralAsh};
      }
      & > input::placeholder {
        color: ${colors.charcoal};
        opacity: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      & > input {
        user-select: none;
      }
    }
    & > .MuiOutlinedInput-input {
      font-size: ${pxToRem(16)};
      font-family: 'Montserrat Medium' !important;
      padding: ${pxToRem(10)} 0px;
    }
    & > .MuiOutlinedInput-notchedOutline {
      border: none !important;
    }
  `,
  textBold: css`
    .MuiInputBase-input {
      font-family: 'Montserrat Bold' !important;
    }
  `,
  cancelIcon: css`
    color: ${colors.slate} !important;
    &.MuiButtonBase-root {
      &.MuiIconButton-root {
        &:hover {
          background: transparent !important;
          border: 1px solid transparent !important;
        }
      }
    }
  `,
  iconContainer: css`
    &.MuiInputAdornment-root {
      margin-right: 4px !important;
    }
  `,
  iconSearch: css`
    color: ${colors.slate} !important;
  `,
};

export default styles;
